<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <div class="mt-2">
              <router-link :to="{ path: '/fixace/pruvodce' }">
                <v-btn color="primary" large class="ml-0 mt-0 mb-3 mr-3" depressed v-if="aktualni!=null">Dokončit předchozí fixaci</v-btn>
              </router-link>
              <v-btn color="primary" large class="mt-0 ml-0 mb-3" :class="{'v-btn--block':$vuetify.breakpoint.xs}" depressed :flat="aktualni!=null" :loading="novaFixaceLoading" @click="novaFixace">Zahájit novou fixaci</v-btn>
            </div>

            <h3 class="mt-2 ml-3">Předchozí fixace</h3>
            <div class="table-border__radius elevation-1 mt-3">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{props.item.id}}</td>
                  <td>{{props.item.datum | formatDateFull}}</td>
                  <td>
                    <span v-if="props.item.dokonceno">Dokončeno</span>
                    <span v-else-if="props.item.zruseno">Zrušeno</span>
                    <span v-else>Nedokončeno</span>
                  </td>
                  <!--<td>
                    <span class="green--text darken-3" v-if="objednavka_dodavatelum">Objednáno</span>
                    <v-btn color="primary" depressed v-else class="ma-0">Vytvořit objednávku</v-btn>
                  </td>-->
                  <td class="subheading text-xs-right">
                    <router-link :to="{ path: '/fixace/' + props.item.id }" v-if="props.item.dokonceno">
                      <v-btn color="primary" flat>Detail</v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      dialog: false,
      loading: true,
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Datum fixace', value: 'datum', sortable: false },
        { text: 'Stav', value: 'dokonceno', sortable: false },
        //{ text: 'Objednávka u dodavatele', value: 'objednavka_dodavatelum', sortable: false },
        { text: '', value: 'id', sortable: false }
      ],
      items: [],
      aktualni: null,
      novaFixaceLoading: false,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
    }
  },
  watch: {
    pagination () {
      this.loadFixace();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.loadFixace();
  },
  methods: {
    loadFixace () {
      this.counter++;
      window.API.post("fixace/search", {
        pagination: this.pagination,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.aktualni = body.aktualni;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.loading = false;
      }.bind(this));
    },
    novaFixace () {
      this.novaFixaceLoading = true;
      window.API.post("fixace", {}).then((b) => {
        this.novaFixaceLoading = false;
        if (b.success) {
          this.$router.push({ path: "/fixace/pruvodce" });
        }
      }).catch((e) => {
        console.log(e);
      })
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Fixace/Fixace.vue